import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import { Link } from 'react-router-dom';

import TextLink from '@redbubble/design-system/react/TextLink';

import styles from './Tab.css';

const Tab = ({ children, active, to }) => {
  return (
    <TextLink>
      {props => (
        <Link
          {...props}
          to={to}
          className={cnames(styles.container, { [styles.active]: active })}
        >
          {children}
        </Link>
      )}
    </TextLink>
  );
};

Tab.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  to: PropTypes.shape({
    pathname: PropTypes.string
  })
};

Tab.defaultProps = {
  active: false
};

export default Tab;
